<template>
  <div id="app">
    <myheader></myheader>
    <div class="header-bj w-100 h-100 wow bounceInUp pc">
      <img
        v-if="banner!==undefined"
        class="w-100 h-100"
        :src="`http://www.waternaida.com/${banner}`"
        alt
      />
    </div>
    <div class="mb">
        <img class="w-100 mb" src="../../static/img/about/mb_about_banner.png" alt />
    </div>
    <div class="Breadcrumb">
      <el-breadcrumb class="Breadcrumb_item" separator-class="el-icon-arrow-right">
        <span>
          <i class="el-icon-minus"></i> Current position：
        </span>
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>ABOUT US</el-breadcrumb-item>
        <!--<el-breadcrumb-item>News</el-breadcrumb-item>-->
      </el-breadcrumb>
    </div>
    <div class="main w-100">
      <el-tabs class="main_menu" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="COMPANY PROFILE" name="first">
          <div class="pane1 wow bounceInUp" data-wow-duration="1s">
            <span class="pane1_head" v-html="company.name"></span>
            <span class="pane1_main" v-html="company.content"></span>
          </div>
          <div class="pane1-1 wow bounceInUp">
            <span class="pane1_1_txt">Company Organization Chart</span>
            <img class="pane1_1_img" src="../img/about/main_img.png" alt />
          </div>
          <div class="pane1-2 wow bounceInUp">
            <span class="pane1_2_txt">Our Factory Review</span>
            <!-- <span class="pane1_2_txt1">We are a self-produced water purifier manufacturer</span> -->
            <div class="pane1-2-img row">
              <viewer :images="images">
                <img
                  class="col-lg-3 col-md-6 col-sm-6 mb-sm-4 mb-xs-1"
                  v-for="(item,index) in images"
                  :src="item"
                  :key="index"
                />
              </viewer>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="COMPANY SCENE" name="second">
          <div class="pane2 row wow bounceInUp">
            <div
              class="pane2-row col-lg-4 col-md-6 col-sm-6"
              v-for="(item,index) in jihua.slice((currentPage- 1)*pagesize,currentPage*pagesize)"
              :key="index"
            >
              <div class="pane2-item">
                <img class="pane2-img w-100" :src="`http://www.waternaida.com/${item.image}`" alt />
                <span class="pane2-txt">{{item.name}}</span>
              </div>
            </div>
          </div>
          <el-pagination
            class="main_download1_pag"
            background
            layout="prev, pager, next"
            :page-size="pagesize"
            @current-change="current_change"
            :current-page.sync="currentPage"
            :pager-count="5"
            :total="jihua.length"
          ></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="CERTIFICATES" name="third">
          <div class="pane3 wow bounceInUp">
            <viewer class="row" :images="zhengshu">
              <div class="col-lg-4 col-md-6 col-sm-6 third-cl" v-for="(item,index) in zhengshu" :key="index">
                <div class="honor-img">
                    <img class="w-100" :src="`http://www.waternaida.com/${item.image}`" />
                </div>
                <span>{{item.name}}</span>
              </div>
            </viewer>
          </div>
        </el-tab-pane>
        <el-tab-pane label="QUALITY IMPORTANCE" name="fourth">
          <div class="pane4 wow bounceInUp">
            <div class="pane4_main1 row">
              <img class="col-lg-5 col-md-5 col-sm-6" src="../img/about/img4-1.png" alt />
              <div class="col-lg-7 col-md-7 col-sm-6">
                <div>
                  <span>Quality: a fundamental requirement</span>
                  <span>Adopting a quality policy is essential for factory as it is closely linked to performance and also forms the backbone of our sustainable development strategy.</span>
                </div>
              </div>
            </div>
            <img class="w-100 pane4_main_bj1" src="../img/about/img4-bj-1.png" alt />
            <div class="pane4_main1 pane4_main2 row">
              <div class="col-lg-7 col-md-5 col-sm-6">
                <div>
                  <span>
                    From production to service: operational
                    excellence through quality
                  </span>
                  <span>
                    Our quality management system is the cornerstone of our strategy and a guarantee of the reliability, performance and durability of our products.We use this as the foundation for all our activities,striving for operational excellence at all levels.
                    That is why our quality policy is about more than just production: it concerns each and every employee , making sure we work together to achieve a common goal.
                  </span>
                </div>
              </div>
              <img class="col-lg-5 col-md-7 col-sm-6" src="../img/about/img4-2.png" alt />
            </div>
            <img class="w-100" src="../img/about/img4-bj-2.png" alt />
            <div class="pane4_main1 pane4_main2 row">
              <img class="col-lg-5 col-md-5 col-sm-6" src="../img/about/img4-3.png" alt />
              <div class="col-lg-7 col-md-7 col-sm-6">
                <div>
                  <span>Product conformity</span>
                  <span>The quality of our solutions is essential to support complex, critical systems. Combining durability, technical quality and ease of installation, our products deliver total confidence in system performance. They conform to the most stringent regulations and standards.</span>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="HOW TO CONTROL OUR QUALITY" name="five">
          <div class="pane5 wow bounceInUp">
            <img class="w-100" src="../img/about/img5-1.png" alt />
            <div class="pane5-txt">
              <span>
                <p class="pane5-txt-all pane5-txt-header">1. PURPOSE</p>
                <p
                  class="pane5-txt-all"
                >To establish a procedure to ensure that material purchase, manufacturing process, finished products and after-sales are in controlled condition.</p>
                <p class="pane5-txt-all pane5-txt-header">2.SCOPE</p>
                <p
                  class="pane5-txt-all"
                >Applicable to all the procedures such as material purchase, manufacturing process, finished products and after-sales.</p>
                <p class="pane5-txt-all pane5-txt-header">3. RESPONSIBILITY</p>
                <p
                  class="pane5-txt-all"
                >3.1. The warehouse is responsible for the inspection of material purchase,subcontracted processing, processing with supplied material and finished products out of stock.</p>
                <p
                  class="pane5-txt-all"
                >3.2. The workshop is responsible for the inspection of finished products put in storage.</p>
                <p
                  class="pane5-txt-all"
                >3.3. The R&D department is responsible for establishing SIP and QC drawing.</p>
                <p
                  class="pane5-txt-all"
                >3.4. The quality department is responsible for executing SIP and QC drawing.</p>
                <p
                  class="pane5-txt-all"
                >3.5. The quality department is responsible for establishing SOP.</p>
                <p
                  class="pane5-txt-all"
                >3.6. The purchasing department is responsible for disposing of the unqualified material purchase, the unqualified subcontracted processing,and the unqualified processing with supplied material.</p>
                <p
                  class="pane5-txt-all"
                >3.7. The production department is responsible for inspecting the execution of the management of Nonconforming Products.</p>
                <p class="pane5-txt-all pane5-txt-header">4. PROCUDURE</p>
                <el-collapse accordion>
                  <el-collapse-item class="pane5_4 is-active">
                    <template slot="title">
                      <img class="mr-3" src="../img/about/椭圆.png" alt />
                      <span class="pane5_4_header">4.1、 Raw material/parts Quality Control</span>
                    </template>
                    <img class="pane5_4_img w-100 mt-4" src="static/img/about/procudure1.jpg" alt />
                  </el-collapse-item>
                  <el-collapse-item class="pane5_4">
                    <template slot="title">
                      <img class="mr-3" src="../img/about/椭圆.png" alt />
                      <span class="pane5_4_header">4.2、 Process Quality Control</span>
                    </template>
                    <img class="pane5_4_img w-100 mt-4" src="static/img/about/procudure2.jpg" alt />
                  </el-collapse-item>
                  <el-collapse-item class="pane5_4">
                    <template slot="title">
                      <img class="mr-3" src="../img/about/椭圆.png" alt />
                      <span class="pane5_4_header">4.3、Finished goods storage process</span>
                    </template>
                    <img class="pane5_4_img w-100 mt-4" src="static/img/about/procudure3.jpg" alt />
                  </el-collapse-item>
                  <el-collapse-item class="pane5_4">
                    <template slot="title">
                      <img class="mr-3" src="../img/about/椭圆.png" alt />
                      <span class="pane5_4_header">4.4、 New supplier sample / after-sales customer complaint sample inspection process</span>
                    </template>
                    <img class="pane5_4_img w-100 mt-4" src="static/img/about/procudure4.jpg" alt />
                  </el-collapse-item>
                </el-collapse>
                <p class="pane5-txt-all pane5-txt-header">5.QC Process related records</p>
                <p
                  class="pane5-txt-all"
                >"Delivery Order", "Purchase Order", "Incoming Inspection Record", "Corrective Preventive Action List", "Non-Conforming Product Review Form", "Initial Sample Inspection Report", "Sample Test Report", "Inspection Record"</p>
                <p class="pane5-txt-all pane5-txt-header">6. Remark</p>
              </span>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <myfooter class="footer"></myfooter>
  </div>
</template>
<style scoped>
#app {
  width: 100%;
  margin: 0 auto;
  background-color: #ffffff;
}
.third-cl{
    margin-bottom: 50px;
}
.third-cl span{
    color: #464748;
    margin-top: 25px;
}
.honor-img{
    position: relative;
    margin:0 15%;
    box-shadow:0px 0px 4px 1px rgba(59,59,59,0.11);
}
.pane5_4_img {
  background-color: #f6f6f6;
}
.header-bj {
  margin-top: 40px;
}
.pane5_4_header {
  color: gray;
}
.pane5-txt-all {
  text-align: left;
  color: gray;
}
.pane5-txt-header {
  font-size: 24px;
  color: #0684fa;
}
.pane5 {
  width: 80%;
  margin: 0 auto;
  margin-top: 3%;
}
.pane4_main_bj1 {
  margin-top: -130px;
}

.pane4_main1 {
  width: 80%;
  margin: 0 auto;
  margin-top: 50px;
}
.pane4_main2 {
  margin-top: -80px;
}
.pane4_main1 > div {
  position: relative;
}
.pane4_main1 > div > div > :first-child {
  text-align: left;
  font-size: 30px;
  margin-bottom: 30px;
}
.pane4_main1 > div > div > :last-child {
  text-align: left;
  font-size: 18px;
}
.pane4_main1 > div > div > span {
  text-align: left;
}
.pane4_main1 > div > div {
  position: absolute;
  top: 50%;
}
.pane3-low {
  margin-top: 18px;
}
.pane3 {
  width: 80%;
  margin: 0 auto;
  margin-top: 50px;
}
.pane3 > div {
  height: 50%;
}
.pane3-img4 {
  padding-top: 121px;
}
.pane3 > div > img,
span {
  display: block;
  text-align: center;
}
.pane3 > div > span {
  margin-bottom: 50px;
}
.pane3 > div > div:nth-child(5) {
  /*padding-top: 7%;*/
}
.main_download1_pag {
  width: 100%;
  margin: 0 auto;
  margin-top: 40px;
}
.pane2-row {
  padding-left: 7px;
  padding-right: 7px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.pane2-item-span {
  width: 10px;
}
.pane2-item {
  border: 0px solid #000;
  border-radius: 10px;
  margin-top: 10px;
  text-align: center;
  background-size: cover;
  padding: 0;
  box-shadow: 0px 1px 5px #888888;
}
.pane2-item > img {
  border: 0px solid #000;
  border-radius: 10px 10px 0 0;
}
.pane2 {
  width: 80%;
  margin: 0 auto;
  display: flex;
  margin-top: 50px;
}
.pane2-txt {
  display: none;
  width: 100%;
  font-size: 18px;
  height: 80px;
  line-height: 80px;
}
.pane2-item:hover {
  background-color: #0168b7;
  color: white;
}
.pane2-img {
  display: block;
  width: 100%;
}
.pane1-2-img {
  width: 80%;
  margin: 0 auto;
  margin-top: 120px;
  padding-bottom: 120px;
}
.pane1-2-img > img {
  margin-bottom: 15px;
}
.pane1_1_img {
  width: 80%;
  display: block;
  padding-top: 50px;
  margin: 0 auto;
  text-align: center;
  padding-bottom: 200px;
}
.pane1_2_txt {
  color: black;
  font-size: 40px;
  text-align: center;
  width: 100%;
  display: block;
}
.pane1_2_txt1 {
  color: black;
  font-size: 16px;
  text-align: center;
  width: 100%;
  display: block;
  margin-top: 20px;
}
.pane1_1_txt {
  color: black;
  font-size: 40px;
  text-align: center;
  width: 100%;
  display: block;
  padding-top: 250px;
}
.pane1-2 {
  width: 100%;
  height: 100%;
  background: url("../img/about/main_footer_bj.png");
  text-align: center;
  background-size: cover;
}
.pane1-1 {
  width: 100%;
  height: 100%;
  background: url("../img/about/main_bj.png");
  text-align: center;
  background-size: cover;
  margin-top: 50px;
}
.pane1_main {
  display: block;
  padding-top: 100px;
  width: 80%;
  margin: 0 auto;
  color: #918c8c;
}
.pane1_head {
  display: block;
  font-size: 40px;
  text-align: center;
  color: #1f77ee;
  padding-top: 80px;
}
.pane1 {
  width: 80%;
  height: 100%;
  background: url("../img/about/worldmap.png");
  text-align: center;
  background-size: cover;
  margin: 0 auto;
  margin-top: 80px;
}
.main >>> .el-tabs__header {
  width: 80%;
  margin: 0 auto;
}

.main_menu {
  width: 100%;
  margin: 0 auto;
}
.Breadcrumb {
  /* background: lightblue; */
  display: block;
  width: 80%;
  margin: 0 auto;
  /* float: right; */
  margin-bottom: 100px;
}
.Breadcrumb_item > span {
  float: left;
  display: block;
}
.Breadcrumb_item {
  float: right;
  /* background-color: lightcoral; */
}
@media screen and (max-width: 1200px) {
  .header-bj {
    margin-top: 0px;
  }
}
@media screen and (max-width: 992px) {
  .pane4_main1 > div > div {
    top: 20%;
  }
  .pane4_main1 > div > div > :first-child {
    font-size: 16px;
  }
  .pane4_main1 > div > div > :last-child {
    font-size: 14px;
  }
  .pane4_main1 > div {
    z-index: 999;
  }
}
@media screen and (max-width: 768px) {
  .pane1 {
    width: 90%;
  }
  .pane1_main {
    width: 100%;
  }
  .pane1-2-img {
    width: 90%;
  }
  .pane1-2-img > img {
    margin-top: 3%;
    -webkit-box-flex: 0;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .pane4_main1 > div > div {
    top: 20%;
  }
  .Breadcrumb{
    display: inline-block;
    text-align:left;
  }
  .Breadcrumb_item{
    float: left;
  }
}
@media screen and (max-width: 576px) {
  .pane1-2-img > div > img {
    width: 50%;
    margin-top: 3%;
    -webkit-box-flex: 0 !important;
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
  .pane4_main1 > img {
    width: 50%;
    display: none;
  }
  .pane4_main1 > div > div > :first-child {
    font-size: 18px;
  }
  .pane4_main1 > div > div > :last-child {
    font-size: 16px;
  }
  .pane4_main1 > div > div {
    position: relative;
  }
  .pane2 {
    width: 98%;
  }
  .pane4_main1 {
    width: 98%;
  }
  .pane4 {
    height: 100%;
  }
  .pane5-txt-all {
    font-size: 18px;
  }
  .pane1_head {
    font-size: 18px;
    padding-top: 0;
  }
  .pane1_main > span {
    font-size: 16px;
    text-align: left;
  }
  .pane1_1_txt {
    font-size: 18px;
    padding-top: 15%;
  }
  .pane1_2_txt {
    font-size: 18px;
  }
  .pane1_main {
    padding-top: 5%;
  }
  .pane1_1_img {
    padding-top: 5%;
    padding-bottom: 15%;
  }
  .pane1-2-img {
    margin-top: 5%;
    padding-bottom: 5%;
  }
  .pane4_main2 {
    margin-top: 0;
  }
  .pane4_main1 {
    margin-top: 0;
  }
}
</style>
<script>
import myfooter from "./zzj/footer";
import myheader from "./zzj/header";
import WOW from "wowjs";
export default {
  data() {
    return {
      activeName: "five",
      banner: [],
      images: [
        require("../../static/img/about/img1.png"),
        require("../../static/img/about/img2.png"),
        require("../../static/img/about/img3.png"),
        require("../../static/img/about/img4.png")
      ],
      zhengshu: [],
      jihua: [],
      company: [],
      pagesize: 6, //每页多少数据
      currentPage: 1
    };
  },
  components: {
    myfooter: myfooter,
    myheader: myheader
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    current_change(currentPage) {
      //改变当前页
      this.currentPage = currentPage;
    },
  },
  created() {
    this.axios
      .get("/api/banner/index?categoryID=17&language=1")
      .then(res => {
        this.banner = res.data.imgList[0].image;
        console.log(this.banner);
      })
      .catch(err => {
        console.log(err);
      });

    this.axios
      .get("/api/single/honor?language=1")
      .then(res => {
        this.zhengshu = res.data.honorList;
        console.log(this.zhengshu);
      })
      .catch(err => {
        console.log(err);
      });

    this.axios
      .get("/api/single/plant?language=1")
      .then(res => {
        this.jihua = res.data.plantList;
        console.log(this.jihua);
      })
      .catch(err => {
        console.log(err);
      });

    this.axios
      .get("/api/single/company")
      .then(res => {
        this.company = res.data.companyInfo;
        console.log(this.company);
      })
      .catch(err => {
        console.log(err);
      });
  },
  mounted() {
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      mobile: true,
      live: true
    });
    wow.init();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/about4.vue